import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  constructor() {
  }

  setUser(user, reset = true) {
    if (user) {
      const { id, email, name, streetAddress, phone } = user;
      this.setItem('user', { id, email, name, streetAddress, phone });
    } else {
      this.setItem('user', null);
    }

    if (reset) {
      this.setItem('name', null);
      this.setItem('EMail', null);
      this.setItem('streetAddress', null)
      this.setItem('phone', null);
    }
  }

  setItem(key, value) {
    if (value === null) {
      localStorage.removeItem(key);
      return;
    }

    const timestamp = new Date().getTime();
    const json = { value, timestamp };
    localStorage.setItem(key, JSON.stringify(json));
  }

  getItem(key) {
    const item = localStorage.getItem(key);

    let json = null;
    try {
      json = JSON.parse(item) || null;
    } catch (e) {
    }

    if (json == null) {
      localStorage.removeItem(key);
      return null;
    }

    const timestamp = new Date().getTime();
    if (typeof json.timestamp === 'undefined') {
      localStorage.removeItem(key);
      return null;
    }
    if (timestamp - json.timestamp > 1000 * 60 * 60 * 2) {
      localStorage.removeItem(key);
      return null;
    } else {
      this.setItem(key, json.value);
    }

    return json.value;
  }
}
